// @flow

export const CREATE = 'CREATE'
export const EDIT = 'EDIT'
export const CLONE = 'CLONE'

export const HTML_TEXT_TYPE = 'html'
export const PLAIN_TEXT_TYPE = 'plain'
